import React, { useRef, useState, useEffect } from "react";
import firebase from "firebase";
import { auth } from "../firebase";
import { useAuthState } from "react-firebase-hooks/auth";
import { ChatEngine } from "react-chat-engine";
import axios from "axios";
import { useHistory } from "react-router-dom";

import styled from "styled-components";

function Chat() {
  const history = useHistory();
  const [user] = useAuthState(auth);
  const [loading, setLoading] = useState(true);

  const getFile = async (url) => {
    const response = await fetch(url);
    const data = await response.blob();
    return new File([data], "userPhoto.jpg", { type: "image/jpeg" });
  };

  useEffect(() => {
    if (!user) {
      history.push("/");
      return;
    } else
      axios
        .get("https://api.chatengine.io/users/me", {
          headers: {
            "project-id": "85768cf3-491a-4ca5-9065-1cf8899e8828",
            "user-name": user.email,
            "user-secret": user.uid,
          },
        })
        .then(() => {
          setLoading(false);
        })
        .catch(() => {
          const formdata = new FormData();
          formdata.append("email,", user.email);
          formdata.append("username", user.displayName);
          formdata.append("secret", user.uid);
          getFile(user.photoURL).then((avatar) => {
            formdata.append("avatar", avatar, avatar.name);

            axios
              .post("https://api.chatengine.io/users", formdata, {
                headers: {
                  "private-key": "a5c84e54-ce1b-4d07-883a-48f303e73e2c",
                },
              })
              .then(setLoading(false))
              .catch((error) => console.log(error));
          });
        });
  }, [user, history]);

  if (!user || loading) return "Loading....";

  return (
    <>
      <ChatContainer>
        <ChatNavContainer>
          <button onClick={() => auth.signOut()}> Logout</button>

          <LogoTab></LogoTab>

          <Logout></Logout>
        </ChatNavContainer>
        <ChatEngine
          height="calc(100vh-66px)"
          userName={user.displayName}
          userSecret={user.uid}
          projectID="85768cf3-491a-4ca5-9065-1cf8899e8828"
        />
      </ChatContainer>
    </>
  );
}

export default Chat;

const ChatContainer = styled.div``;
const ChatNavContainer = styled.div``;
const LogoTab = styled.div``;
const Logout = styled.div``;
